import { Box, Flex } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import useFeriados from "core/features/feriados/hooks/useFeriados";
import useDeleteFeriados from "core/features/feriados/hooks/useDeleteFeriados";
import { FeriadoResponsePaginate } from "core/features/feriados/typings";
import { useEffect, useState } from "react";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";
import ModalFeriados from "./components/ModalFeriados";
import SelectMonthYear from "./SelectMonthYear";
import moment from "moment";
import useFeriadosColumns from "./useFeriadosColumns";
import PageHeader from "components/Page/PageHeader";
import { useLoading } from "components/GlobalLoading";
import { showConfirm, showSuccess, showError } from "infra/helpers/alerta";

function Feriados({ tenantId }: { tenantId: string }) {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState<string | undefined>("");
  const [selectedDate, setSelectedDate] = useState(moment());
  const {
    data: feriado,
    isFetching,
    refetch,
  } = useFeriados(tenantId, {
    page,
    search,
  });

  const { mutate: handleDelete, isLoading: isLoadingDelete } =
    useDeleteFeriados();

  const columns = useFeriadosColumns(selectedDate.format("YYYY"));
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [editFeriado, setEditFeriado] = useState<
    FeriadoResponsePaginate | undefined
  >();

  useEffect(() => {
    if (!isOpenModal) {
      setEditFeriado(undefined);
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (editFeriado) {
      setIsOpenModal(true);
    }
  }, [editFeriado]);

  const _isLoading = isFetching;

  useLoading(isLoadingDelete);

  return (
    <>
      <PageHeader
        onClick={() => setIsOpenModal(true)}
        title="Feriados"
        titleButton="Adicionar"
      />
      {isOpenModal ? (
        <ModalFeriados
          defaultValue={editFeriado}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSaved={() => {
            setIsOpenModal(false);
            refetch();
          }}
          tenantId={tenantId}
        />
      ) : null}

      <Row gutter={32}>
        <Col sm={24}>
          <Box>
            <NewTable
              title={() => (
                <HeaderTable value={search || ""} onSearch={setSearch}>
                  <Flex flex={1} justifyContent="flex-end">
                    <SelectMonthYear
                      bg="white"
                      value={selectedDate}
                      onChange={(date) => date && setSelectedDate(date)}
                    />
                  </Flex>
                </HeaderTable>
              )}
              loading={_isLoading}
              columns={columns}
              dataSource={feriado?.items ?? []}
              actions={[
                {
                  title: "Editar",
                  onClick: (v: FeriadoResponsePaginate) => {
                    if (v.padrao) {
                      return showError(
                        "Não é possivel editar um feriado nacional"
                      );
                    }
                    setEditFeriado(v);
                  },
                },
                {
                  title: "Excluir",
                  onClick: async (v: FeriadoResponsePaginate) => {
                    const { isConfirmed } = await showConfirm();

                    if (isConfirmed) {
                      handleDelete(v.id!, {
                        onSuccess: async () => {
                          await showSuccess();

                          refetch();
                        },
                      });
                    }
                  },
                },
              ]}
              customPagination={{
                onChangePage: setPage,
                currentPage: feriado?.meta?.currentPage ?? 0,
                itemsPerPage: feriado?.meta?.itemsPerPage ?? 0,
                totalItems: feriado?.meta?.totalItems ?? 0,
              }}
            />
          </Box>
        </Col>
      </Row>
    </>
  );
}

export default Feriados;
